var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoGear = function SvgIcoGear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#9A77FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M134.206 57.799h-12.851a52.6 52.6 0 0 0-6.134-14.827l9.081-9.082a3.777 3.777 0 0 0 0-5.341l-12.463-12.463a3.776 3.776 0 0 0-5.341 0l-9.082 9.082a52.6 52.6 0 0 0-14.827-6.134V6.182a3.777 3.777 0 0 0-3.778-3.777H61.186a3.777 3.777 0 0 0-3.777 3.777v12.851a52.6 52.6 0 0 0-14.827 6.134L33.5 16.085a3.777 3.777 0 0 0-5.341 0L15.696 28.548a3.777 3.777 0 0 0 0 5.342l9.081 9.08a52.6 52.6 0 0 0-6.134 14.828H5.795a3.777 3.777 0 0 0-3.777 3.777V79.2a3.777 3.777 0 0 0 3.777 3.777h12.85a52.6 52.6 0 0 0 6.134 14.828l-9.08 9.081a3.776 3.776 0 0 0 0 5.341L28.16 124.69a3.777 3.777 0 0 0 5.342 0l9.08-9.081a52.6 52.6 0 0 0 14.828 6.134v12.851a3.777 3.777 0 0 0 3.777 3.777h17.625a3.777 3.777 0 0 0 3.777-3.777v-12.851a52.6 52.6 0 0 0 14.828-6.134l9.081 9.081a3.776 3.776 0 0 0 5.341 0l12.463-12.463a3.776 3.776 0 0 0 0-5.341l-9.081-9.081a52.6 52.6 0 0 0 6.134-14.828h12.851a3.777 3.777 0 0 0 3.777-3.777V61.575a3.777 3.777 0 0 0-3.777-3.777z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M70 104.378c18.772 0 33.99-15.218 33.99-33.991S88.772 36.396 70 36.396c-18.774 0-33.992 15.218-33.992 33.99 0 18.774 15.218 33.992 33.991 33.992"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C52F1",
    d: "M64.65 50.06 36.93 94.768c-2.6 4.193.416 9.611 5.35 9.611h55.436c4.934 0 7.95-5.418 5.35-9.611L75.349 50.061c-2.461-3.97-8.238-3.97-10.7 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M69.998 64.093v18.883M69.998 93.048v1.259"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9A77FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M36.59 76.681a34 34 0 0 1-.582-6.294c0-18.773 15.218-33.991 33.991-33.991s33.991 15.218 33.991 33.99c0 2.151-.199 4.255-.581 6.295"
  })));
};
export default SvgIcoGear;